import SiteButton from '@/components/atoms/SiteButton'

interface ClosingCtaProps {
    headline: string;
}

// Button is always "Buy unimo" — the point of commitment, not a joke, per
// content/unimo-industry-page-copy.md. No sub-line: the old live-customer
// claims under this CTA don't survive into the rebuild.
// pb-section-gap (48px) is the gap to ReferencesBlock's top border, which sits
// flush at that section's own edge — without this the divider is flush against the button.
export function ClosingCta({ headline }: ClosingCtaProps) {
    return (
        <section className="pb-section-gap pt-section-gap">
            <h2 className="max-w-2xl text-2xl font-medium text-unimo-slate lg:text-4xl">{headline}</h2>
            <SiteButton href="/pricing" className="mt-8 w-fit">
                Buy unimo
            </SiteButton>
        </section>
    )
}

export default ClosingCta
